import { State } from '@progress/kendo-data-query';
import { HeaderThElement } from '@progress/kendo-react-data-tools';
import {
  GridColumnMenuFilter,
  GridColumnMenuProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
} from '@progress/kendo-react-grid';
import { CustomFilter } from '../CustomFilter';

export const ColumnMenu = (props: GridColumnMenuProps) => {
  return (
    <div>
      <GridColumnMenuFilter {...props} expanded={true} />
    </div>
  );
};

export const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
  <HeaderThElement
    columnId={props.thProps?.columnId || ''}
    {...props.thProps}
    style={{
      fontSize: '0.9rem',
    }}
  >
    {props.children}
  </HeaderThElement>
);

export const CenteredHeaderCustomCell = (props: GridCustomHeaderCellProps) => (
  <HeaderThElement
    columnId={props.thProps?.columnId || ''}
    {...props.thProps}
    style={{
      fontSize: '0.9rem',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    {props.children}
  </HeaderThElement>
);

export const CustomCell = (props: GridCustomCellProps) => {
  return (
    <td
      {...props.tdProps}
      colSpan={1}
      style={{
        fontSize: '0.9rem',
      }}
    >
      {props.children}
    </td>
  );
};

export const CenteredCustomCell = (props: GridCustomCellProps) => {
  return (
    <td
      {...props.tdProps}
      colSpan={1}
      style={{
        fontSize: '0.9rem',
        textAlign: 'center',
      }}
    >
      {props.children}
    </td>
  );
};

export const CustomColumnMenu = (
  props: GridColumnMenuProps & { dataState: State }
) => {
  return (
    <div>
      <GridColumnMenuFilter
        {...props}
        expanded={true}
        filterUI={filterProps => (
          <CustomFilter {...filterProps} dataState={props.dataState} />
        )}
      />
    </div>
  );
};
